import scriptLoader from 'react-async-script-loader'

import createEnvironment from 'config/env'
import { compose, defaultProps, withPropsOnChange } from 'recompose'

declare global {
  interface Window {
    google: any
  }
}

type Props = {
  autoComplete: google.maps.places.AutocompleteService
  okStatus: google.maps.places.PlacesServiceStatus
  placesService: google.maps.places.PlacesService
}

export type WithGooglePlacesProps = Props

export const initializeGooglePlaces = () => {
  if (window.google && window.google.maps) {
    return {
      autoComplete: new window.google.maps.places.AutocompleteService(),
      okStatus: window.google.maps.places.PlacesServiceStatus.OK,
      placesService: new window.google.maps.places.PlacesService(document.createElement('div')),
    }
  } else {
    return {}
  }
}

const env = createEnvironment()

const withGooglePlaces = compose<Props, {}>(
  scriptLoader([
    `https://maps.googleapis.com/maps/api/js?key=${env.get('googlePlacesKey')}&libraries=places`,
  ]),
  defaultProps({
    isScriptLoaded: false,
  }),
  withPropsOnChange(['isScriptLoaded'], ({ isScriptLoaded }) => {
    let props = {}
    /* istanbul ignore if */
    if (isScriptLoaded) {
      props = initializeGooglePlaces()
    }
    return props
  }),
)

export default withGooglePlaces
